<template>
  <div class="mine page">
    <div class="header">
      <div class="user-wrapper" @click="doLogin()">
        <van-image
          round
          class="user_img"
          :src="avatarSrc"
          @error="onAvatarError"
        >
          <template v-slot:loading>
            <van-loading type="spinner" />
          </template>
          <template v-slot:error>
            <img src="/img/head/1.png" class="avatar-fallback" alt="" />
          </template>
        </van-image>
        <div class="login-content">
          <p class="login-btn">{{ displayName }}</p>
          <p class="login-label">
            {{ $t("my.point") }}:{{ creditText }}
          </p>
        </div>
        <div class="login-content1" v-if="token">
          <p class="login-btn1">{{ levelText }}</p>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="cell-card">
        <div class="cell-row" @click="goBalance()">
          <div class="left">
            <img class="icon" src="/img/yuer.png" alt="" />
            <span>{{ $t("my.detail") }}</span>
          </div>
          <div class="right">
            <span class="money" v-if="token">{{ userInfo.money || "0.00" }}</span>
            <van-icon name="replay" class="refresh" @click.stop="refresh()" />
          </div>
        </div>
      </div>

      <div class="cell-card">
        <div class="cell-row" @click="doWithdrawal()">
          <div class="left">
            <img class="icon" src="/img/chongzhi.png" alt="" />
            <span>{{ $t("my.withdraw") }}</span>
          </div>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
        <div class="cell-row" @click="goPath('/RechargeList')">
          <div class="left">
            <img class="icon" src="/img/tixian.png" alt="" />
            <span>{{ $t("my.account_detail") }}</span>
          </div>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
        <div class="cell-row" @click="goPath('/WithdrawRecord')">
          <div class="left">
            <img class="icon" src="/img/qita.png" alt="" />
            <span>{{ $t("my.withdraw_record") }}</span>
          </div>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
        <div class="cell-row" @click="goPath('/Personalreport')">
          <div class="left">
            <img class="icon" src="/img/qita.png" alt="" />
            <span>{{ $t("my.my_statement") }}</span>
          </div>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
      </div>

      <div class="cell-card">
        <div class="cell-row" @click="goPath('/Infomation')">
          <div class="left">
            <img class="icon" src="/img/qita.png" alt="" />
            <span>{{ $t("my.personal_center") }}</span>
          </div>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
        <div class="cell-row" @click="goPath('/GameRecord')">
          <div class="left">
            <img class="icon" src="/img/qita.png" alt="" />
            <span>{{ $t("my.task_record") }}</span>
          </div>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
        <div class="cell-row" @click="goPath('/Notice')">
          <div class="left">
            <img class="icon" src="/img/qita.png" alt="" />
            <span>{{ $t("my.information_announcement") }}</span>
          </div>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
        <div class="cell-row" @click="goPath('/Setting')">
          <div class="left">
            <img class="icon" src="/img/shezhi.png" alt="" />
            <span>{{ $t("setting.setting") }}</span>
          </div>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      avatarBroken: false,
      token: !!localStorage.getItem("token"),
    };
  },
  computed: {
    displayName() {
      if (!this.token) return this.$t("setting.log_reg");
      return this.userInfo.username || this.$t("setting.log_reg");
    },
    creditText() {
      if (!this.token) return "";
      const v = this.userInfo.xinyu;
      if (v === undefined || v === null || v === "") {
        return this.userInfo.point !== undefined ? this.userInfo.point : "";
      }
      return v;
    },
    levelText() {
      const v = this.userInfo.vip;
      if (v === undefined || v === null || v === "" || v === 0 || v === "0") {
        return "VIP";
      }
      return String(v).replace(/^LV/i, "");
    },
    avatarSrc() {
      if (this.avatarBroken) return "/img/head/1.png";
      const src = (this.userInfo.header_img || "").trim();
      if (!src || /zxbuk\.oss-cn-hongkong\.aliyuncs\.com/i.test(src)) {
        return "/img/head/1.png";
      }
      return src;
    },
  },
  methods: {
    onAvatarError() {
      this.avatarBroken = true;
    },
    needLogin() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return true;
      }
      return false;
    },
    doLogin() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Infomation" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },
    goPath(path) {
      if (this.needLogin()) return;
      this.$router.push({ path });
    },
    doWithdrawal() {
      if (this.needLogin()) return;
      const base = this.$store.getters.getBaseInfo || {};
      if (Number(base.close_withdraw) === 1) {
        this.$toast.fail(this.$t("setting.forbid"));
        return;
      }
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200) {
          if (!(res.data && res.data.is_bank)) {
            this.$toast.fail(this.$t("setting.set_bank"));
            this.$router.push({ path: "/Setbank" });
            return;
          }
          this.$http({ method: "get", url: "user_info" }).then((infoRes) => {
            if (infoRes.code === 200) {
              this.userInfo = infoRes.data || {};
              this.$store.commit("setUserInfoValue", this.userInfo);
              if (!this.userInfo.paypassword) {
                this.$toast.fail(this.$t("setting.set_withdraw_pwd"));
                this.$router.push({ path: "/SetPayPassword" });
                return;
              }
              this.$router.push({ path: "/Withdraw" });
            } else if (infoRes.code === 401) {
              this.$toast(infoRes.msg);
            }
          });
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    goBalance() {
      if (this.needLogin()) return;
      this.$router.push({ path: "/Personalreport" });
    },
    refresh() {
      if (this.needLogin()) return;
      this.getUserInfo(true);
    },
    getUserInfo(showToast) {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.avatarBroken = false;
          this.userInfo = res.data || {};
          this.token = true;
          this.$store.commit("setUserInfoValue", this.userInfo);
          if (showToast) this.$toast(this.$t("reservation.refresh"));
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: "/Login" });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      this.getUserInfo();
    } else {
      this.userInfo = {};
    }
  },
};
</script>

<style scoped>
.mine.page {
  min-height: 100vh;
  background: #000000;
  padding-bottom: 160px;
  box-sizing: border-box;
}
.header {
  background: #000;
  padding: 50px 40px 56px;
  border-bottom: 1px solid rgba(201, 168, 76, 0.35);
}
.user-wrapper {
  display: flex;
  align-items: center;
}
.user_img {
  width: 120px;
  height: 120px;
  flex-shrink: 0;
}
.avatar-fallback {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #c9a84c;
  background: #141414;
}
::v-deep .user_img .van-image__img {
  border: 4px solid #c9a84c;
  box-sizing: border-box;
  background: #141414;
}
.login-content {
  flex: 1;
  margin-left: 28px;
  color: #c9a84c;
  min-width: 0;
}
.login-btn {
  margin: 0;
  font-size: 36px;
  font-weight: 600;
  line-height: 1.3;
  color: #c9a84c;
}
.login-label {
  margin: 12px 0 0;
  font-size: 28px;
  color: #c8c8c8;
}
.login-content1 {
  flex: 0 0 auto;
  margin-left: 16px;
  background: linear-gradient(135deg, #c9a84c, #8a6d2e);
  border-radius: 30px;
  height: 56px;
  line-height: 56px;
  padding: 0 28px;
  text-align: center;
  border: 1px solid #c9a84c;
}
.login-btn1 {
  margin: 0;
  font-size: 28px;
  color: #000;
  font-weight: 700;
}
.content {
  padding: 24px 24px 0;
  margin-top: -10px;
}
.cell-card {
  background: #141414;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 20px;
  border: 1px solid rgba(201, 168, 76, 0.45);
}
.cell-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 28px;
  border-bottom: 1px solid rgba(201, 168, 76, 0.2);
}
.cell-row:last-child {
  border-bottom: none;
}
.cell-row .left {
  display: flex;
  align-items: center;
  color: #c9a84c;
  font-size: 30px;
}
.cell-row .left .icon {
  width: 46px;
  height: 46px;
  margin-right: 20px;
  object-fit: contain;
}
.cell-row .right {
  display: flex;
  align-items: center;
}
.cell-row .money {
  margin-right: 16px;
  color: #c9a84c;
  font-size: 30px;
  font-weight: 600;
}
.cell-row .refresh {
  font-size: 40px;
  color: #c8c9cc;
}
</style>
